import React, { useState, useMemo, useEffect, useRef } from "react";
import styled from "styled-components";
import { TextField, InputAdornment } from "@material-ui/core";
import Send from "img/genai/Send.svg";
import { fetchModules } from "../api/genapi";
import { SlideRecom } from "./sliderec/SlideRecom";
import DropDownButtons from "components/DropDownButton";
import { handleSlides } from "./utils/handlePages";
import { toast } from "react-toastify";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import CustomModal from "components/customModal";
import ConfirmationPopup from "components/ConfirmationPopup";

export const ModuleInput = ({
  onSend,
  selectedeDetail,
  selectedSlide,
  productCountry,
  setProductCountry,
  handleUserMessage,
  textShow,
  setTextShow,
  handleProceedeDetail,
  edetailtextShow,
  SetedetailTextShow,
  handleModuledata,
  setSelectedEdetail,
  setSelectedSlide,
  slidetextShow,
  SetSlideTextShow,
  setMessages,
  setShowChat,
  showChat,
  setUserText,
  slideBubbleState,
  disconnect,
  reconnect,
  dropDownlist,
  setDropDownlist,
  moduleCreation,
  comboSlides,
  setComboSlides,
  setMultiModuleCreation,
  startNew,
  goNextPrompt,
  slidePopup,
  generatemultimodBtn,
  generateManyModules,
  cancelbtn,
  handleCancelGeneration,
  restartMod,
  assemblyshow,
  setAssemblyshow,
  inputControll,
  resetPop,
  multiIP,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [isSlideRecomModalOpen, setIsSlideRecomModalOpen] = useState(false);
  const [lineCount, setLineCount] = useState(1);
  const [showStartNewModal, setShowStartNewModal] = useState(false);
  const { restartModules, setRestartModules } = restartMod;
  const { showModuleCreation, setShowModuleCreation } = moduleCreation;
  const { showNewBubble, setShowNewBubble } = startNew;
  const { goforward, setGoForward } = goNextPrompt;
  const { generateMultiMod, setGenerateMultiMod } = generatemultimodBtn;
  const { inputHidden, setInputHidden } = inputControll;
  const { recModules, setRecModules } = resetPop;
  const { isMultiline, setIsMultiline } = multiIP;

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    if (value.trim().length > 0) {
      setIsMultiline(false);
    }
    const hasActualNewlines = value.includes("\n") || value.includes("\r");
    const isLongText = value.length > 161; // Adjust based on your UI

    // Consider it multiline if either:
    // 1. Has actual newlines (Enter key)
    // 2. Is very long text that will wrap visually
    const isMultilineMode = hasActualNewlines || isLongText;

    setIsMultiline(isMultilineMode);

    // Estimate line count
    const newlineCount = (value.match(/\n/g) || []).length;
    const estimatedLinesFromLength = Math.ceil(value.length / 60);
  };
  const handleSendClick = () => {
    if (inputValue.trim()) {
      setUserText(inputValue);
      onSend(inputValue);
      setInputValue("");
      setIsMultiline(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSendClick();
      setIsMultiline(false);
    }
    // Shift+Enter will allow new lines
  };
  const havingDropdown = dropDownlist?.topiclist.length > 0;
  const hasSelection = useMemo(() => {
    return (
      (edetailtextShow && selectedeDetail !== null) ||
      textShow ||
      (slidetextShow && selectedSlide !== null)
    );
  }, [
    selectedeDetail,
    edetailtextShow,
    textShow,
    slidetextShow,
    selectedSlide, // Keep this dependency but now we handle null checks properly
  ]);

  const handleSlideSuggestion = () => {
    // setSelectedSlide(null);
    const userMessage = {
      id: Date.now(),
      text: "Recommend more slides based on selection",
      sender: "user",
      timestamp: new Date().toISOString(),
    };
    setMessages((prev) => [...prev, userMessage]);
    setTimeout(() => {
      setIsSlideRecomModalOpen(true);
    }, 1000);
  };

  const handleProceedSlides = (
    selectedRecommendedSlideIds,
    selectedRecommendedSlidesData,
  ) => {
    const uniqueRecommendedSlidesData = selectedRecommendedSlidesData.filter(
      (slide) =>
        !slideBubbleState.selectedBeforeRec.slideIds.includes(slide.pageId),
    );

    const uniqueRecommendedSlideIds = uniqueRecommendedSlidesData.map(
      (slide) => slide.pageId,
    );

    const combinedSlideData = {
      originalSlides: slideBubbleState.selectedBeforeRec,
      recommendedSlides: uniqueRecommendedSlideIds,
      recommendedSlidesData: uniqueRecommendedSlidesData,
      allSlides: {
        assetId: slideBubbleState.selectedBeforeRec.assetId,
        slideIds: [
          ...slideBubbleState.selectedBeforeRec.slideIds,
          ...uniqueRecommendedSlideIds, // No duplicates now
        ],
        slidenums: [
          ...slideBubbleState.selectedBeforeRec.slidenums,
          ...uniqueRecommendedSlidesData.map((slide) => slide.slidenum),
        ],
        signedUrls: [
          ...slideBubbleState.selectedBeforeRec.signedUrls,
          ...uniqueRecommendedSlidesData.map((slide) => ({
            pageId: slide.pageId,
            signedUrl: slide.signedUrl,
          })),
        ],
      },
    };
    setComboSlides(combinedSlideData);
    const botResponse = {
      id: Date.now() + 1,
      sender: "bot",
      timestamp: new Date().toISOString(),
      data: combinedSlideData,
      responseType: "slideRes",
    };
    setMessages((prev) => [...prev, botResponse]);
    setIsSlideRecomModalOpen(false);
    setTimeout(() => {
      setTextShow(true);
      setShowModuleCreation(true);
    }, 3300);
  };

  const handleValidProceed = () => {
    setInputValue("");
    const userMessage = {
      id: Date.now() + 1,
      sender: "user",
      timestamp: new Date().toISOString(),
      data: [],
      text: "Yes, proceed",
    };
    setMessages((prev) => [...prev, userMessage]);
    handleUserMessage(productCountry);
    setTextShow((s) => !s);
    disconnect();
  };

  const handleOneModuleCreation = async () => {
    try {
      setTextShow(false);
      const userMessage = {
        id: Date.now(),
        text: "Make system recommended modules across selected slide",
        sender: "user",
        timestamp: new Date().toISOString(),
      };
      console.log(comboSlides, `combo`);

      setMessages((prev) => [...prev, userMessage]);
      if (!comboSlides || Object.keys(comboSlides).length === 0) {
        throw new Error(
          "No slides data available. Please select slides first.",
        );
      }

      // Transform the slides data to the correct structure
      const transformedSlides = handleSlides(comboSlides);

      if (!transformedSlides || transformedSlides.slideIds.length === 0) {
        throw new Error("No valid slides found to process.");
      }

      // Pass the transformed slides to handleModuledata
      await handleModuledata(transformedSlides, comboSlides);
    } catch (error) {
      console.error("Error processing selection:", error);

      toast.error(error.message || "Failed to process slides selection", {
        position: "top-right",
        autoClose: 5000,
      });

      // Reset states to allow retry
      setTextShow(true);
      setShowModuleCreation(true);
    }
  };
  const handleOneModuleCreationFirst = async () => {
    try {
      setTextShow(false);
      const userMessage = {
        id: Date.now(),
        text: "Make system recommended modules across selected slide",
        sender: "user",
        timestamp: new Date().toISOString(),
      };
      setMessages((prev) => [...prev, userMessage]);
      if (!selectedSlide || Object.keys(selectedSlide).length === 0) {
        throw new Error(
          "No slides data available. Please select slides first.",
        );
      }

      // Pass the transformed slides to handleModuledata
      await handleModuledata(selectedSlide);
    } catch (error) {
      console.error("Error processing selection:", error);

      toast.error(error.message || "Failed to process slides selection", {
        position: "top-right",
        autoClose: 5000,
      });

      // Reset states to allow retry
      setTextShow(true);
      setShowModuleCreation(true);
    }
  };

  const handleStartNew = () => {
    setShowStartNewModal(true);
  };

  const confirmStartNew = () => {
    setProductCountry(null);
    setDropDownlist({ topiclist: [], confirmationPop: false });
    setIsMultiline(false);
    setInputHidden(false);
    setTextShow(false);
    setInputValue("");
    setMessages([]);
    setShowChat(false);
    setShowModuleCreation(false);
    setIsSlideRecomModalOpen(false);
    setSelectedEdetail(null);
    setSelectedSlide(null);
    setComboSlides({});
    setShowNewBubble(false);
    setRestartModules(false);
    setShowStartNewModal(false);
    disconnect();
    reconnect();
  };

  const closeStartNewModal = () => {
    setShowStartNewModal(false);
  };
  const shouldHideSendIcon = selectedeDetail || selectedSlide;

  const StartNewButton = ({
    onStartNew,
    width = "90px",
    children = "Start new",
    ...props
  }) => {
    return (
      <ProceedText
        $shouldHideInputBox={shouldHideInputBox}
        onClick={handleStartNew}
        width={width}
        {...props}
      >
        {children}
      </ProceedText>
    );
  };

  useEffect(() => {
    setRecModules(false);
  }, [selectedSlide, selectedeDetail]);
  const shouldHideInputBox = selectedeDetail || selectedSlide;
  const { cancelGenerate } = cancelbtn;

  const formatLabel = (name) => {
    if (!name) return "Topic";
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  };
  const label = formatLabel(dropDownlist?.nameOfdropdown);
  useEffect(() => {
    // Clear input when it becomes hidden/disabled
    if (inputHidden && inputValue) {
      setInputValue("");
      setIsMultiline(false);
    }
  }, [inputHidden, inputValue]);
  return (
    <>
      <MainSearch
        $hasSelection={hasSelection}
        $shouldHideInputBox={shouldHideInputBox}
        $multiline={isMultiline}
      >
        <SearchContainer
          $showChat={showChat}
          $hasSelection={hasSelection}
          $shouldHideInputBox={shouldHideInputBox}
          $multiline={isMultiline}
          $lines={lineCount}
        >
          {havingDropdown && !showNewBubble && (
            <DropDownButtons
              showCustomList={true}
              dropDownlistName={label}
              customOptions={dropDownlist?.topiclist}
              handleClick={(selectedIndex) => {
                const selectedElement =
                  dropDownlist?.topiclist[selectedIndex - 1];
                setTimeout(() => {
                  onSend(`${label}: ${selectedElement}`);
                  setTextShow(false);
                  setDropDownlist({ topiclist: [], confirmationPop: false });
                }, 1000);
              }}
              totalElements={dropDownlist?.topiclist.length}
              createdByMeFlag={null}
              moduleCountSummary={{
                createdByMe: 0,
                createdByOthers: 0,
                totalCount: dropDownlist?.topiclist.length,
              }}
              isFiltersApplied={false}
            />
          )}

          {selectedeDetail !== null && edetailtextShow && (
            <ProceedText
              $shouldHideInputBox={shouldHideInputBox}
              marginBottom="6px"
              width="161px"
              onClick={() => {
                handleProceedeDetail(selectedeDetail);
                SetedetailTextShow(false);
                // setSelectedEdetail(null);
                // setSelectedSlide(null);
                // setTextShow(false);
                setTextShow(true);
                setShowNewBubble(true);
              }}
            >
              Proceed with selection
            </ProceedText>
          )}

          {slidetextShow && !restartModules && selectedSlide !== null && (
            <SlideBox>
              {/* {!slideBubbleState.isShow && (
                <ProceedText
                  $shouldHideInputBox={shouldHideInputBox}
                  width="276px"
                  marginBottom="6px"
                  onClick={handleSlideSuggestion}
                >
                  Recommend more slides based on selection
                </ProceedText>
              )} */}
              <ProceedText
                $shouldHideInputBox={shouldHideInputBox}
                width="271px"
                marginBottom="6px"
                onClick={async () => {
                  try {
                    setTextShow(false);
                    SetSlideTextShow(false);
                    setMultiModuleCreation(false);
                    const userMessage = {
                      id: Date.now(),
                      text: "Make one module from each selected slide",
                      sender: "user",
                      timestamp: new Date().toISOString(),
                      rawData: "Proceed with select",
                    };
                    setMessages((prev) => [...prev, userMessage]);
                    await handleModuledata(selectedSlide);
                  } catch (error) {
                    // Keep slide selected if there's an error
                    console.error("Error processing selection:", error);
                  }
                }}
              >
                Make one module from each selected slide
              </ProceedText>
              <ProceedText
                $shouldHideInputBox={shouldHideInputBox}
                width="358px"
                onClick={() => {
                  SetSlideTextShow(false);
                  handleOneModuleCreationFirst();
                  setMultiModuleCreation(true);
                  setTextShow(false);
                }}
              >
                Make system recommended modules across selected slide
              </ProceedText>
              <StartNewButton onStartNew={handleStartNew} width="90" />
            </SlideBox>
          )}
          {cancelGenerate && textShow && (
            <SlideBox>
              <ProceedText
                $shouldHideInputBox={shouldHideInputBox}
                width="auto"
                onClick={handleCancelGeneration}
              >
                Cancel
              </ProceedText>
            </SlideBox>
          )}

          {productCountry &&
            !showNewBubble &&
            textShow &&
            !showModuleCreation &&
            !selectedSlide &&
            !selectedeDetail && (
              <>
                <ShowDetails>
                  <ProceedText width="102px" onClick={handleValidProceed}>
                    Yes, proceed
                  </ProceedText>
                  <StartNewButton onStartNew={handleStartNew} width="90" />
                </ShowDetails>
              </>
            )}

          {textShow && (
            <>
              {/* Only show ShowDetails when there's at least one button to show */}
              {((goforward && !setShowNewBubble) ||
                (dropDownlist?.confirmationPop && !productCountry)) && (
                <ShowDetails $shouldHideInputBox={shouldHideInputBox}>
                  {/* ProceedText depends only on goforward */}
                  {goforward &&
                    !productCountry &&
                    !havingDropdown &&
                    !selectedSlide &&
                    !selectedeDetail && (
                      <ProceedText
                        $shouldHideInputBox={shouldHideInputBox}
                        width="102px"
                        onClick={() => {
                          onSend("Yes, proceed");
                          setTextShow(false);
                          setGoForward(false);
                        }}
                      >
                        Yes, proceed
                      </ProceedText>
                    )}

                  {/* StartNewButton depends on confirmationPop and other conditions */}
                  {dropDownlist?.confirmationPop && !productCountry && (
                    <StartNewButton onStartNew={handleStartNew} width="90" />
                  )}
                </ShowDetails>
              )}
            </>
          )}
          {/* for the start new btn */}

          {!edetailtextShow &&
            (showNewBubble || assemblyshow || restartModules) &&
            textShow && (
              <SlideBox>
                {restartModules && (
                  <ProceedText
                    $shouldHideInputBox={shouldHideInputBox}
                    width="189px"
                    onClick={() => {
                      setRestartModules(false);
                      setAssemblyshow(true);
                      setShowNewBubble(true);
                      setTextShow(true);
                      setTimeout(() => {
                        setAssemblyshow(false);
                      }, 3000);
                    }}
                  >
                    Create one module per slide
                  </ProceedText>
                )}
                <StartNewButton onStartNew={handleStartNew} width="90" />
              </SlideBox>
            )}
          {/* for multimodulegenerate */}
          {generateMultiMod && textShow && (
            <SlideBox>
              <ProceedText
                style={{ marginLeft: "12px" }}
                $shouldHideInputBox={shouldHideInputBox}
                width="135px"
                onClick={() => {
                  // onSend(" Generate Modules");
                  setTextShow(false);
                  setGenerateMultiMod(false);
                  generateManyModules();
                }}
              >
                Generate modules
              </ProceedText>
            </SlideBox>
          )}
          {/* {textShow && restartModules && (
            <SlideBox style={{ marginLeft: "12px" }}>
              <ProceedText
                $shouldHideInputBox={shouldHideInputBox}
                width="189px"
                onClick={() => {
                  setRestartModules(false);
                  setAssemblyshow(true);
                  setTimeout(() => {
                    setAssemblyshow(false);
                  }, 3000);
                }}
              >
                Create one module per slide
              </ProceedText>
            </SlideBox>
          )} */}
          {/* for modulecreation bubbles */}
          {showModuleCreation &&
            !generateMultiMod &&
            !cancelGenerate &&
            textShow && (
              <SlideBox>
                {!recModules && (
                  <>
                    <ShowDetails $shouldHideInputBox={shouldHideInputBox}>
                      <ProceedText
                        width="271px"
                        $shouldHideInputBox={shouldHideInputBox}
                        onClick={async () => {
                          try {
                            setRecModules(true);
                            setTextShow(false);
                            SetSlideTextShow(false);
                            setMultiModuleCreation(false);
                            const userMessage = {
                              id: Date.now(),
                              text: "Make one module from each selected slide",
                              sender: "user",
                              timestamp: new Date().toISOString(),
                            };
                            setMessages((prev) => [...prev, userMessage]);
                            const transformedSlides = comboSlides
                              ? handleSlides(comboSlides)
                              : selectedSlide;
                            await handleModuledata(
                              transformedSlides,
                              comboSlides,
                            );
                          } catch (error) {
                            // Keep slide selected if there's an error
                            console.error("Error processing selection:", error);
                          }
                        }}
                      >
                        Make one module from each selected slide
                      </ProceedText>
                    </ShowDetails>
                    <ShowDetails $shouldHideInputBox={shouldHideInputBox}>
                      <ProceedText
                        $shouldHideInputBox={shouldHideInputBox}
                        width="358px"
                        onClick={() => {
                          handleOneModuleCreation();
                          setMultiModuleCreation(true);
                          setTextShow(false);
                          setRecModules(true);
                        }}
                      >
                        Make system recommended modules across selected slide
                      </ProceedText>
                    </ShowDetails>{" "}
                  </>
                )}
                <ShowDetails $shouldHideInputBox={shouldHideInputBox}>
                  <StartNewButton onStartNew={handleStartNew} width="90" />
                </ShowDetails>
              </SlideBox>
            )}
          <input
            type="file"
            accept="application/pdf"
            multiple
            style={{ display: "none", fontSize: "14px" }}
            id="fileUpload"
          />

          {!shouldHideInputBox && (
            <MainBox
              $multiline={isMultiline}
              $isExpanded={lineCount > 1}
              $lines={lineCount}
            >
              <TextFieldWrapper
                $multiline={isMultiline}
                $isExpanded={lineCount > 1}
                $lines={lineCount}
              >
                <StyledTextareaAutosize
                  $multiline={isMultiline}
                  aria-label="chat input"
                  placeholder={
                    inputHidden
                      ? "Type to chat with me !"
                      : "Type to chat with me !"
                  }
                  value={inputValue}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                  disabled={inputHidden || selectedeDetail || selectedSlide}
                  minRows={1}
                  maxRows={5}
                />
              </TextFieldWrapper>
              <StyledSendIcon
                $multiline={isMultiline}
                src={Send}
                alt="Send"
                onClick={
                  selectedeDetail || selectedSlide || !inputValue.trim()
                    ? undefined
                    : handleSendClick
                }
                disabled={
                  selectedeDetail || selectedSlide || !inputValue.trim()
                }
              />
            </MainBox>
          )}
        </SearchContainer>
      </MainSearch>
      {isSlideRecomModalOpen && (
        <SlideRecom
          setIsSlideRecomModalOpen={setIsSlideRecomModalOpen}
          handleProceedSlides={handleProceedSlides}
          selectedCount={slideBubbleState.selectedCount}
          selectedSlide={slideBubbleState.selectedBeforeRec}
          SetSlideTextShow={SetSlideTextShow}
          slidePopup={slidePopup}
        />
      )}

      {/* custom modal */}
      <CustomModal
        displayModal={showStartNewModal}
        hideModal={closeStartNewModal}
        size="sm"
        dilogClassName="alertModalSmall"
      >
        <ConfirmationPopup
          title="Start New"
          text="Starting a new chat will discard all previous actions. Are you sure?"
          closeModal={closeStartNewModal}
          handleConfirm={confirmStartNew}
          primaryButtonTitle="PROCEED"
          secondaryButtonTitle="CANCEL"
        />
      </CustomModal>
    </>
  );
};
const MainSearch = styled.section`
  background: #f5f5f7;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  min-height: ${({ $shouldHideInputBox, $hasSelection, $multiline }) =>
    $shouldHideInputBox
      ? "108px"
      : $multiline
        ? "203px"
        : $hasSelection
          ? "142px"
          : "108px"};

  height: ${({ $shouldHideInputBox, $hasSelection, $multiline }) =>
    $shouldHideInputBox
      ? "108px"
      : $multiline
        ? "203px"
        : $hasSelection
          ? "142px"
          : "108px"};

  padding-left: 60px;
  padding-right: 60px;
  padding-bottom: ${({ $shouldHideInputBox, $hasSelection }) =>
    $shouldHideInputBox ? "23px" : $hasSelection ? "20px" : "23px"};
`;

const SearchContainer = styled.div`
  border-radius: 12px;
  padding: 20px;
  width: 100%;
  background: #fff;
  position: relative;

  /* 🔑 One sizing rule only */
  min-height: ${({ $shouldHideInputBox, $hasSelection }) =>
    $shouldHideInputBox ? "85px" : $hasSelection ? "122px" : "85px"};

  max-height: 181px;
  height: auto;

  overflow: visible;

  visibility: ${({ $showChat }) => ($showChat ? "visible" : "hidden")};
  border: 1px solid #dddfdd;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.04);

  display: flex;
  flex-direction: column;
  justify-content: ${({ $shouldHideInputBox }) =>
    $shouldHideInputBox ? "center" : "flex-end"};
`;

const ProceedText = styled.article`
  background: #f2f6fa;
  text-align: center;
  border-radius: 20px;
  padding: 6px 16px;
  cursor: pointer;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #203662;
  font-weight: 700;
  font-size: 12px;
  width: ${(props) => props.width || "auto"}; // Default width if not provided
  margin-bottom: ${({ $shouldHideInputBox, marginBottom }) =>
    $shouldHideInputBox ? "0px" : marginBottom || "0px"};
`;

const ShowDetails = styled.article`
  display: flex;
  justify-content: start;
  gap: 12px;
  align-items: center;
  // margin-bottom:6px;
`;

const SlideBox = styled.div`
  display: flex;
  gap: 12px;
  flex-direction: row;
`;

const StyledSendIcon = styled.img`
  width: 20px;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  transition: opacity 0.2s ease;
  filter: ${(props) =>
    props.disabled ? "grayscale(1) brightness(0.6)" : "none"};
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  height: 24px;
  margin-right: 20px;

  ${({ $multiline }) =>
    $multiline &&
    `
    margin-top: 6px;
  `}
`;
const MainBox = styled.div`
  margin-right: 12px;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: ${({ $multiline }) => ($multiline ? "10px" : "8px")};
  border: 1px solid #dddfdd;
  border-radius: 12px;
  overflow: hidden; /* Ensure textarea doesn't overflow the border */

  /* Let the box size dynamically based on content */
  height: auto;
  min-height: 45px; /* Minimum height to match textarea */

  ${({ $isExpanded }) =>
    $isExpanded &&
    `
    transform: translateY(-20px);
  `}

  /* Remove focus outline for the entire box */
  &:focus-within {
    border-color: #dddfdd !important;
    outline: none !important;
    box-shadow: none !important;
  }

  &::placeholder {
    color: #878888;
    font-size: 14px;
    font-weight: 600;
    opacity: 1;
  }
`;
const TextFieldWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  // margin-top: 8px;
  width: 100%;

  /* Ensure this is the stacking context */
  position: relative;
  z-index: 1;
  /* Add conditional margin for multiline textarea */
  ${({ $lines }) =>
    $lines === 5 &&
    `
    margin-top: 12px;
    margin-bottom: 12px;
  `}

  /* Target the textarea inside when it has customScrollBar class */
  .customScrollBar {
    /* Add right margin for scrollbar spacing */
    margin-right: 12px !important;

    /* Override scrollbar styles */
    &::-webkit-scrollbar-track {
      ${({ $multiline }) =>
        $multiline &&
        `
        margin-top: 12px !important;
        margin-bottom: 12px !important;
      `}
    }

    &::-webkit-scrollbar-thumb {
      margin-right: 12px !important;
    }
  }
`;

const SendButtonWrapper = styled.div`
  position: absolute;
  right: 12px;
  bottom: 12px;
  z-index: 1001; /* Higher than textarea's z-index */
  transition: bottom 0.2s ease;

  ${({ $isMultiline }) =>
    $isMultiline &&
    `
    bottom: 42px;
  `}
`;

const StyledTextareaAutosize = styled(TextareaAutosize).attrs(() => ({
  className: "customScrollBar",
}))`
  width: 100%;
  font-size: 14px;
  line-height: 1.4;
  padding: 12px 3px 12px 32px;
  background: ${({ disabled }) =>
    disabled ? "#fff" : "#fff"}; /* Keep white background even when disabled */
  margin-right: 12px;
  /* Remove ALL borders, outlines, and box-shadows */
  border: none !important;
  outline: none !important;
  box-shadow: none !important;

  /* Add high z-index to grow over other elements */
  z-index: 1000;
  position: relative;

  /* Force upward growth by anchoring to bottom */
  min-height: 45px;
  max-height: 106px;
  height: auto;

  /* The key: text starts at bottom, grows upward */
  align-self: flex-end;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  /* Disabled styles */
  ${({ disabled }) =>
    disabled &&
    `
    background: #fff !important; /* Keep white background */
    color: #999 !important; /* Gray text color */
    cursor: not-allowed !important; /* Show not-allowed cursor on hover */
    opacity: 0.7; /* Slight transparency */
    user-select: none; /* Prevent text selection */
    
    /* Change placeholder color when disabled */
    &::placeholder {
      color: #999 !important;
    }
  `}

  /* Ensure no focus states add borders */
  &:focus {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
  }

  /* Active state */
  &:active {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
  }

  /* Hover state */
  &:hover {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;

    /* Show disabled cursor when disabled on hover */
    ${({ disabled }) =>
      disabled &&
      `
      cursor: not-allowed !important;
    `}
  }

  &:focus::placeholder {
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  /* Style placeholder specifically */
  &::placeholder {
    color: #aaa;
    transition: color 0.2s ease;
  }

  overflow-y: auto !important;
  resize: none !important;
  box-sizing: border-box !important;
`;
